<template>
	<div id="clientDns" class="jc-view">
		<JuniperPageHeader :back="'/juniper/clients/edit/' + client.id" :title="client ? client.name : ''" subtitle="Widgets" />
		<div class="row mb-3">

			<div class="col-md-4">
				<div class="card">
					<div class="card-body">
						<h5>
							Widget locations
							<span class="text-uppercase text-primary">{{ theme }}</span> theme
						</h5>
						<div class="row mt-3">
							<div v-for="location in widgetsLocations" :key="location.code" class="col-12 mb-3">
								<h6>{{ location.name }}</h6>
								<div class="wl-location">
									<div v-if="location.widgets.length == 0" class="wl-empty">
										There are no widgets in this location
									</div>
									<div
										class="wl-widget-row"
										v-for="(widg, i) in location.widgets"
										:key="'loc-widg-' + i + widg.code"
									>
										<div class="widget-name">
											<h5 class="p-0 m-0">{{ widg.name }}</h5>
										</div>
										<div class="widget-actions">
											<button
												class="act-row-btn"
												title="Widget settings"
												@click="widgetSettings(widg)"
											>
												<font-awesome-icon :icon="['fas', 'cogs']" />
											</button>
											<button
												@click="removeWidgetFromLocation(i, location)"
												class="act-row-btn act-row-btn--danger"
												title="Remove widget"
											>
												<font-awesome-icon :icon="['fas', 'trash-alt']" />
											</button>
										</div>
									</div>

									<button
										data-bs-toggle="modal"
										data-bs-target="#widgetsModal"
										class="wl-add-btn"
										@click="selectedWidgetLocationCode = location.code"
									>
										+ Add widget
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-md-8">
				<div class="card" style="min-height:400px">
					<div class="card-body">
						<div class="row">
							<div class="col-md-12 d-flex justify-content-between flex-column">
								<h5>
									Available Widgets:
									<span class="text-uppercase text-primary">{{ theme }}</span> theme
								</h5>
								<small>ℹ️ To change theme go to customizer section</small>
								<div class="row mt-3">
									<div v-for="(widget, i) in widgets" :key="i + widget.code" class="col-md-6 mb-3">
										<div class="juniper-widget">
											<div class="widget-header">
												<h5 class="p-0 m-0">{{ widget.name }}</h5>
												<div>
													<button
														class="act-row-btn"
														title="Widget settings"
														@click="toggleSettings(widget.code)"
													>
														<font-awesome-icon :icon="['fas', 'cogs']" />
													</button>
												</div>
											</div>
											<div class="widget-settings" v-if="displaySettings == widget.code">
												<div class="variable-wrapper">
													<div class="text-center" v-if="widget.variables.length == 0">
														There is no settings for this widget 🤷‍♂️
													</div>
													<div
														v-for="(variable, i) in widget.variables"
														:key="i + variable"
														class="variable-item"
													>
														<div
															class="form-group mb-2"
															v-if="variable.code.includes('_COUNT')"
														>
															<label for="">{{ variable.name }}</label>
															<input
																type="number"
																v-model="variable.value"
																class="form-control form-control-sm w-50"
															/>
														</div>
														<div
															class="form-group mb-2"
															v-else-if="variable.code.includes('_CODE')"
														>
															<label for="">{{ variable.name }}</label>
															<textarea
																type="number"
																rows="10"
																v-model="variable.value"
																class="form-control form-control-sm"
															/>
														</div>
														<div class="form-group mb-2" v-else>
															<label for="">{{ variable.name }}</label>
															<input
																type="text"
																v-model="variable.value"
																class="form-control form-control-sm"
															/>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-md-12 d-flex justify-content-end mt-2">
				<button @click="saveOptions()" class="btn btn-primary ">
					<font-awesome-icon
						:icon="['fas', updateLoading ? 'spinner' : 'save']"
						:class="[updateLoading ? 'fa-spin' : '']"
					/>
					Update
				</button>
			</div>
		</div>

		<!-- Modal Widgets -->
		<div
			class="modal fade"
			id="widgetsModal"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabindex="-1"
			aria-labelledby="widgetsModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="widgetsModalLabel">
							Available widgets
						</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div v-for="widget in widgets" :key="'w-' + widget.code" class="col-12">
								<button
									class="wl-pick-btn"
									@click="addWidgetToLocation(widget)"
								>
									{{ widget.name }}
								</button>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
							Close
						</button>
					</div>
				</div>
			</div>
		</div>
		<!-- Modal Widgets Settings -->
		<div
			class="modal fade"
			id="widgetsSettingsModal"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabindex="-1"
			aria-labelledby="widgetsSettingsModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="widgetsSettingsModalLabel">
							Widget Settings
						</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div v-for="(variable, i) in settingWidget.variables" :key="i + variable" class="variable-item">
							<div class="form-group mb-2" v-if="variable.code.includes('_COUNT')">
								<label for="">{{ variable.name }}</label>
								<input type="number" v-model="variable.value" class="form-control w-50" />
							</div>
							<div class="form-group mb-2" v-else-if="variable.code.includes('_CODE')">
								<label for="">{{ variable.name }}</label>
								<textarea type="number" rows="10" v-model="variable.value" class="form-control" />
							</div>
							<div class="form-group mb-2" v-else>
								<label for="">{{ variable.name }}</label>
								<input type="text" v-model="variable.value" class="form-control" />
							</div>
						</div>
					</div>
					<div class="modal-footer d-flex justify-content-between">
						<div>
							<button
								type="button"
								class="btn btn-warning float-start d-none"
								@click="restoreWidgetSettings()"
							>
								Restore
							</button>
						</div>
						<div>
							<button type="button" class="btn btn-secondary me-1" data-bs-dismiss="modal">
								Close
							</button>
							<button type="button" class="btn btn-primary" data-bs-dismiss="modal">
								Apply
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import juniperApi from '@/api/juniperApi'
import { Modal } from 'bootstrap'
//import restApi from '../../../api/index'

export default {
	name: 'ClientWidgets',
	data() {
		return {
			loading: false,
			updateLoading: false,
			client: {},
			theme: 'default',
			widgets: [],
			widgetsLocations: [],
			clientOptions: {},
			displaySettings: '',
			$widgetsModal: null,
			$widgetsSettingsModal: null,
			selectedWidgetLocationCode: '',
			settingWidget: {},
			settingWidgetRevision: {} }
	},
	components: {},
	computed: {
		...mapState(['authUser']),
		...mapGetters(['isAuth']) },
	mounted() {
		this.$widgetsModal = new Modal('#widgetsModal')
		this.$widgetsSettingsModal = new Modal('#widgetsSettingsModal')
	},
	created() {
		this.getClient()
	},
	methods: {
		// Get client
		getClient() {
			this.loading = true
			juniperApi
				.get('/clients/' + this.$route.params.id)
				.then(({ data }) => {
					this.client = data
					this.loading = false
					this.getClientOptions()
				})
				.catch(error => {
					this.loading = false
					console.log(error)
				})
		},

		// Get client
		getThemeWidgets() {
			this.loading = true
			juniperApi
				.get('/themes/' + this.$route.params.id + '/' + this.theme + '/widgets')
				.then(({ data }) => {
					this.widgets = data
					this.loading = false
				})
				.catch(error => {
					this.loading = false
					console.log(error)
				})
		},

		saveOptions() {
			this.updateLoading = true
			let widgetsData = [...this.widgets]
			this.clientOptions.widgets_settings_json = widgetsData
			let widgetsLocationsData = [...this.widgetsLocations]
			this.clientOptions.widgets_locations_json = widgetsLocationsData
			juniperApi
				.post('/options/' + this.$route.params.id + '/save', { params: this.clientOptions })
				.then(({ data }) => {
					this.updateLoading = false
					this.$swal.fire({
						icon: 'success',
						title: data.message,
						timer: 2000 })
				})
				.catch(error => {
					this.updateLoading = false
					console.log(error)
				})
		},

		// Get client options
		getClientOptions() {
			this.loading = true
			juniperApi
				.post('/options/' + this.$route.params.id)
				.then(({ data }) => {
					Object.keys(data).forEach(k => {
						if (!k.includes('theme_')) {
							delete data[k]
						}
					})
					this.clientOptions = data
					this.theme = data.theme_active
					this.getThemeWidgets()
					this.getWidgetPlaces()
					this.loading = false
				})
				.catch(error => {
					this.loading = false
					console.log(error)
				})
		},

		// Get client options
		getWidgetPlaces() {
			this.loading = true
			juniperApi
				.post('themes/' + this.$route.params.id + '/' + this.theme + '/widgets-places')
				.then(({ data }) => {
					this.widgetsLocations = data
					this.loading = false
				})
				.catch(error => {
					this.loading = false
					console.log(error)
				})
		},

		toggleSettings(value) {
			if (value == this.displaySettings) {
				this.displaySettings = ''
			} else {
				this.displaySettings = value
			}
		},

		addWidgetToLocation(widget) {
			this.widgetsLocations.forEach(location => {
				if (location.code == this.selectedWidgetLocationCode) {
					location.widgets.push(JSON.parse(JSON.stringify(widget)))
				}
			})
			this.$widgetsModal.hide()
		},

		removeWidgetFromLocation(index, loc) {
			this.widgetsLocations.forEach(location => {
				if (location.code == loc.code) {
					location.widgets.splice(index, 1)
				}
			})
		},

		widgetSettings(widget) {
			this.settingWidget = widget
			this.settingWidgetRevision = JSON.parse(JSON.stringify(widget))
			this.$widgetsSettingsModal.show()
		},

		restoreWidgetSettings() {
			this.settingWidget = this.settingWidgetRevision
		} } }
</script>

<style scoped>
#clientDns {
	padding: 0 0 60px;
	margin-top: 0 !important;
}

.jc-view {
	width: 100%;
}

/* ─── Settings-language pass ─────────────────────────────────────────── */
#clientDns .card {
	border: 1px solid #e6e8ec;
	border-radius: 12px;
	box-shadow: none;
}

#clientDns .form-control {
	border: 1px solid #e6e8ec;
	border-radius: 8px;
	box-shadow: none;
}

#clientDns .form-control:focus {
	border-color: #2b6cff;
	box-shadow: 0 0 0 3px rgba(43, 108, 255, 0.15);
}

#clientDns .form-group label {
	font-size: 0.8rem;
	font-weight: 600;
	color: #374151;
	margin-bottom: 0.25rem;
}

/* Flat buttons */
#clientDns .btn-primary {
	background: transparent;
	color: #111827;
	border: 1px solid #111827;
	border-radius: 8px;
	font-weight: 600;
	box-shadow: none;
}
#clientDns .btn-primary:hover {
	background: #f3f5f9;
	color: #111827;
}
#clientDns .btn-secondary {
	background: transparent;
	color: #6b7280;
	border: 1px solid #e6e8ec;
	border-radius: 8px;
	font-weight: 600;
	box-shadow: none;
}
#clientDns .btn-secondary:hover {
	background: #f3f5f9;
	color: #111827;
	border-color: #d1d5db;
}
#clientDns .btn-warning {
	background: transparent;
	color: #b45309;
	border: 1px solid #fcd9a3;
	border-radius: 8px;
	font-weight: 600;
	box-shadow: none;
}
#clientDns .btn-warning:hover {
	background: #fff7ed;
	border-color: #fbbf24;
	color: #b45309;
}

/* Row action icons — plain gray, colour on hover */
.act-row-btn {
	background: none;
	border: none;
	color: #adb5bd;
	padding: 4px 6px;
	border-radius: 6px;
	cursor: pointer;
	font-size: 13px;
	line-height: 1;
	transition: color 0.15s ease, background 0.15s ease;
}
.act-row-btn + .act-row-btn {
	margin-left: 2px;
}
.act-row-btn:hover {
	color: #2b303b;
	background: #f3f5f9;
}
.act-row-btn--danger:hover {
	color: #dc3545;
	background: #fdecee;
}

/* Widget locations */
.wl-location {
	background: #f7f8fa;
	border: 1px solid #eceef2;
	border-radius: 10px;
	padding: 8px;
}

.wl-empty {
	padding: 14px;
	text-align: center;
	color: #8a909c;
	font-size: 13px;
	border: 1px dashed #d5d9e0;
	border-radius: 8px;
	margin-bottom: 8px;
	background: #fff;
}

.wl-widget-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: #fff;
	border: 1px solid #e6e8ec;
	border-radius: 8px;
	padding: 8px 10px;
	margin-bottom: 8px;
}

.wl-widget-row h5 {
	font-size: 14px;
}

.wl-add-btn {
	width: 100%;
	border: 1px dashed #d5d9e0;
	background: transparent;
	color: #6b7280;
	border-radius: 8px;
	padding: 7px;
	font-size: 13px;
	font-weight: 600;
	cursor: pointer;
	transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.wl-add-btn:hover {
	background: #f3f5f9;
	color: #111827;
	border-color: #c8ccd4;
}

/* Modal widget picker buttons */
.wl-pick-btn {
	width: 100%;
	text-align: left;
	border: 1px solid #e6e8ec;
	background: #fff;
	color: #111827;
	border-radius: 8px;
	padding: 9px 12px;
	margin-bottom: 8px;
	font-size: 13px;
	font-weight: 600;
	cursor: pointer;
	transition: background 0.15s ease, border-color 0.15s ease;
}
.wl-pick-btn:hover {
	background: #f3f5f9;
	border-color: #d1d5db;
}

.juniper-widget {
	border: 1px solid #e6e8ec;
	border-radius: 10px;
	overflow: hidden;
}

.widget-header {
	background-color: #f9fafb;
	padding: 0.75rem 0.875rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #111827;
	border-bottom: 1px solid #f1f3f5;
}

.widget-header h5 {
	font-size: 14px;
}

.widget-settings {
	animation-name: showFromTopAnimation;
	animation-duration: 0.2s;
	animation-timing-function: ease-in-out;
	padding: 1rem;
	border: none;
}
.widget-template {
	animation-name: showFromTopAnimation;
	animation-duration: 0.2s;
	animation-timing-function: ease-in-out;
	padding: 0.5rem;
	margin-top: 1rem;
	padding-top: 0.25rem;
	background-color: bisque;
	border-radius: 10px;
}
.widget-template code pre {
	font-size: 12px;
	padding: 0 0.1rem;
	margin-bottom: 0;
}

@keyframes showFromTopAnimation {
	0% {
		opacity: 0;
		transform: translateY(-10%);
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
}
.widget-action-btn:hover {
	transform: scale(1.1);
}
</style>
